import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

DeleteConfirmation.propTypes = {
  isVisible: PropTypes.any,
  onDelete: PropTypes.any,
  onCancel: PropTypes.any,
  actionName: PropTypes.string,
};

export default function DeleteConfirmation({ isVisible, onDelete, onCancel, actionName = 'Delete' }) {
  return (
    <Dialog open={isVisible} maxWidth="md">
      <DialogTitle>{`Are you sure want to ${actionName}?`}</DialogTitle>
      <DialogActions>
        <Button variant="outlined" onClick={onDelete} color="error">
          {actionName}
        </Button>
        <Button variant="outlined" onClick={onCancel} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
